import {useTranslation} from "react-i18next";
import {useMemo} from "react";

// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
const DATE_FORMAT_OPTIONS = {
    "short": {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    },
};

export function IntlDate({ children, style = 'short' }) {
    const { t } = useTranslation();
    const locale = useMemo(() => t('BCP47LOCALE'), [t]) ;
    const formatter = useMemo(() => new Intl.DateTimeFormat(locale, DATE_FORMAT_OPTIONS[style] ?? {}), [locale]);
    const date = children instanceof Date ? children : new Date(children);
    return formatter.format(date);
}
